<template>
  <div class="question-detail-services" @click="toServices">
    <span :class="{ 'services-text': true, w516: isSticky }">{{
      headInfo.text
    }}</span>
    <img :src="headInfo.icon" alt="" class="icon-services" />
    <serviceEntrance
      ref="services"
      :blank="true"
      :assignHeCongCustomer="{
        channel_flag: 'Platform_content_QA'
      }"
    >
    </serviceEntrance>
  </div>
</template>
<script>
import serviceEntrance from 'app/frontend-lib/component/vue/serviceEntrance/index.vue'
export default {
  components: {
    serviceEntrance
  },
  props: {
    isSticky: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    toServices() {
      this.$emit('toServices')
      // isConsultTarget  1为目标用户 0非目标用户
      const { isConsultTarget = 0, adviser = {} } = this.detail
      if (+isConsultTarget === 1) {
        if (adviser && adviser.skipUrl) {
          window.location.href = adviser.skipUrl
        } else {
          this.$refs.services.showChat()
        }
      } else {
        this.routerPush({
          path: '/qingsu',
          query: {
            hideNavigationBar: 1,
            channel_flag: 'Platform_content_QA'
          }
        })
      }
    }
  },
  computed: {
    headInfo() {
      const { isConsultTarget = 0 } = this.detail
      let info = {
        icon: require('images/qa/questions/icon-services-default.png'),
        text: '没找到满意答案？找专业老师聊聊！'
      }
      if (+isConsultTarget === 1) {
        info = {
          icon: require('images/qa/questions/icon-services.png'),
          text: '没找到满意答案？问问专业老师的意见吧！'
        }
      }
      return info
    },
    detail() {
      return this.$store.state.qaQuestionDetail?.detail || {}
    }
  }
}
</script>
<style lang="scss" scoped>
.question-detail-services {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 24px;
  .services-text {
    display: inline-block;
    width: 0;
    height: 60px;
    background: #6982fa;
    border-radius: 34px 0px 0px 34px;
    font-size: 24px;
    color: #ffffff;
    line-height: 60px;
    margin-top: -4px;
    box-sizing: border-box;
    transition: width 0.5s;
  }
  .w516 {
    width: 516px;
    padding-left: 25px;
  }
  .icon-services {
    width: 78px;
    height: 88px;
    margin-left: -40px;
  }
}
</style>
